export const action_types = {
  SET_AUTHENTICATION: "SET_AUTHENTICATION",
  LOGOUT: "LOGOUT",
  ADD_NEW_TITLE: "ADD_NEW_TITLE",
  ADD_NEW_PAGE_FILTER: "ADD_NEW_PAGE_FILTER",
  ADD_NEW_HELP_TEXT: "ADD_NEW_HELP_TEXT",
};

const logoutService = () => {
  localStorage.clear();
  window.location.reload();
};

export const actions = {
  setAuthentication: (data) => {
    return { type: action_types.SET_AUTHENTICATION, data };
  },
  logout: () => {
    logoutService();
    return { type: action_types.LOGOUT };
  },
  addNewTitle: (title) => {
    return {
      type: action_types.ADD_NEW_TITLE,
      title,
    };
  },
  addNewPageFilter: (page_filter) => {
    return {
      type: action_types.ADD_NEW_PAGE_FILTER,
      page_filter,
    };
  },
  addNewHelpText: (help_text) => {
    return {
      type: action_types.ADD_NEW_HELP_TEXT,
      help_text,
    };
  },
};
